<div id="global-loader">
    <img src="./assets/images/loader.svg" class="loader-img" alt="Loader" />
</div>
<div class="page main-signin-wrapper">
    <section class="signup__area po-rel-z1 pt-100 pb-145">
        <div class="container shapes-div">
            <div class="row">
                <div class="sign__shape">
                    <img src="assets/images/man-1.png" alt="" class="man-1" />
                    <img src="assets/images/man-2.png" alt="" class="man-2" />
                    <img src="assets/images/circle.png" alt="" class="circle" />
                    <img src="assets/images/zigzag.png" alt="" class="zigzag" />
                    <img src="assets/images/dot.png" alt="" class="dot" />
                    <img src="assets/images/sign-up.png" alt="" class="bg" />
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
                    <div class="sign__wrapper white-bg">
                        <div class="sign__header mb-5">
                            <div class="sign__in text-center">
                                <h2>Create ABC ID</h2>
                            </div>
                        </div>
                        <div class="sign__form">
                            <form [formGroup]="abcForm" novalidate>
                                <div class="sign__input-wrapper mb-4">
                                    <h6>Your name as per Aadhaar Card </h6>
                                    <div class="sign__input">
                                        <input required type="text" placeholder="Aadhaar Name"
                                            formControlName="aadhaarName" />
                                        <mat-error class="margin_tp"
                                            *ngIf="abcForm.controls['aadhaarName'].touched && abcForm.controls['aadhaarName'].errors?.required">
                                            Mandatory.
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="sign__input-wrapper mb-4">
                                    <h6>Date of Birth: DD/MM/YYYY </h6>
                                    <div class="sign__input">
                                        <input required type="text" placeholder="Date of Birth"
                                            formControlName="aadhaarDOB" maxlength="10" />
                                        <mat-error class="margin_tp"
                                            *ngIf="abcForm.controls['aadhaarDOB'].touched && abcForm.controls['aadhaarDOB'].errors?.required">
                                            Mandatory.
                                        </mat-error>
                                    </div>
                                </div>
                                <!-- <div class="sign__input-wrapper mb-4">
                                    <h6>Gender</h6>
                                    <div class="sign__input">
                                        <mat-form-field>
                                            <mat-select class="colorblack" formControlName="aadhaarGender" >
                                                <mat-option *ngFor="let item of GenderList" [value]="item.value">
                                                    {{item.label}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>   
                                    </div>   
                                </div>   -->
                                <div class="sign__input-wrapper mb-4">
                                    <h6>Gender (Male/Female) </h6>
                                    <div class="sign__input">
                                        <input required type="text" placeholder="Gender"
                                            formControlName="aadhaarGender" />
                                        <mat-error class="margin_tp"
                                            *ngIf="abcForm.controls['aadhaarGender'].touched && abcForm.controls['aadhaarGender'].errors?.required">
                                            Mandatory.
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="sign__input-wrapper mb-4">
                                    <h6>Aadhaar Number </h6>
                                    <div class="sign__input">
                                        <input required type="text" placeholder="Aadhaar Number"
                                            formControlName="aadhaarNumber" maxlength="12" />
                                        <mat-error class="margin_tp"
                                            *ngIf="abcForm.controls['aadhaarNumber'].touched && abcForm.controls['aadhaarNumber'].errors?.required">
                                            Mandatory.
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="sign__input-wrapper mb-4">
                                    <h6>Mobile Number provided in Aadhaar Card </h6>
                                    <div class="sign__input">
                                        <input required type="text" placeholder="Mobile Number"
                                            formControlName="aadhaarMobile" maxlength="10" />
                                        <mat-error class="margin_tp"
                                            *ngIf="abcForm.controls['aadhaarMobile'].touched && abcForm.controls['aadhaarMobile'].errors?.required">
                                            Mandatory.
                                        </mat-error>
                                    </div>
                                </div>
                                <button class="e-btn w-100 colfff" type="submit" (click)="submit()">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>